import { render, staticRenderFns } from "./Banner6.vue?vue&type=template&id=bb80e3c4"
import script from "./Banner6.vue?vue&type=script&lang=js"
export * from "./Banner6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports